<template>
   <card-seplag :titulo="'RELATÓRIOS'"> 
       <div class="p-col-12">
           <div class="p-grid p-fluid">
                <div class="p-col p-shadow-1 text-center cursor-poiter" @click="tipoRelatorioSelecionado=1">
                    <i class="pi pi-file-pdf"  style="fontSize: 8vw"></i>
                        <label> RELATÓRIO DE DIREITO DE AFASTAMENTO</label>
                </div>
           </div>
       </div>
       <div class="p-col-12" v-if="tipoRelatorioSelecionado && tipoRelatorioSelecionado==1">
            <card-seplag :titulo="'Filtros para o RELATÓRIO DE ACOMPANHAMENTO POR UNIDADE'">
                <Rotulo nome="Orgão da Unidade" cols='12 4' :requerido="true">
                    <Dropdown v-model="orgaoSelecionado" :options="orgaos" optionLabel="descricao" placeholder="Selecione..."  :filter="true" @change="carregaUnidades()"  />
                </Rotulo>                
                <Rotulo nome="Unidades" cols='12 4' v-if="orgaoSelecionado && unidades" >
                    <Dropdown v-model="unidadeSelecionada" :options="unidades" optionLabel="descricao" placeholder="Selecione..."  :filter="true"  />
                </Rotulo>                
                <Rotulo nome="Matricula" cols='12 4' v-if="orgaoSelecionado && unidades">
                    <InputText type="text" v-model="matriculaFiltro"  />
                </Rotulo>            
                <Rotulo nome="Filtro Tipo Afastamento" cols='12 4' v-if="orgaoSelecionado && unidades">
                    <Dropdown v-model="tipoAfastamentoFiltroSelecionado" :options="tipoAfastamentoFiltro" optionLabel="name" placeholder="Selecione..."  />
                </Rotulo>          
                <Rotulo nome="Filtro Fase" cols='12 4' v-if="orgaoSelecionado && unidades">
                    <Dropdown v-model="faseFiltroSelecionado" :options="faseFiltro" optionLabel="name" placeholder="Selecione..."  />
                </Rotulo>          
                <Rotulo nome="Filtro Tipo Jornada" cols='12 4' v-if="orgaoSelecionado && unidades">
                    <Dropdown v-model="tipoJornadaFiltroSelecionado" :options="tipoJornadaFiltro" optionLabel="name" placeholder="Selecione..."  />
                </Rotulo>                
                <div class="p-col-12">
                    <div class="p-grid p-fluid">
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-danger" label="Cancelar"  @click="fecharFiltro()"  icon="pi pi-times" iconPos="left" />
                        </div>
                        <div class="p-col-12 p-md-4">                    
                            <Button class="p-button-success" label="Filtrar"  icon="pi pi-check" iconPos="left" @click="relatorioDireitoAfastamento()"/>
                        </div>
                    </div>
                </div>
            </card-seplag>
       </div>
        <ExibirPDF  v-if="pdfBase64" v-model="exibirPDFDocumento" :tamanhoTela="'70.vw'" :alturaTela="'30.vw'" :tituloTela="nomeModalPDF" :pdfElement="pdfBase64"  />
   </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import ExibirPDF from '@/template/CardExibirPDF.vue'
import { baseApiUrl } from '@/config/global'
export default {
    name: "gerenciaRelatorios",
    components: {CardSeplag,ExibirPDF,Rotulo},
    data: function(){        
		return {
            exibirPDFDocumento: false,
            pdfBase64:"",
            nomeModalPDF: "MODAL PDF",
            orgaos: [],
            orgaoSelecionado: null,
            unidades: [],
            unidadeSelecionada: null,
            tipoAfastamentoFiltro:[
                {name:"Férias",code:1},                
                {name:"Licença Prêmio",code:2}
            ],
            faseFiltro: [
                {name:"Solicitação",code:'SOLICITACAO'}, 
                {name:"Análise",code:"ANALISE"}
            ],
            tipoJornadaFiltro: [
                {name:"Integral",code:'INTEGRAL'}, 
                {name:"Reduzida",code:"REDUZIDA"}
            ],
            status: null,
            matriculaFiltro:null,
            cpfFiltro: null,
            tipoAfastamentoFiltroSelecionado: null,
            faseFiltroSelecionado: null,
            tipoJornadaFiltroSelecionado: null,
            tipoRelatorioSelecionado: null
		}
    },
    methods:{
        async carregarDados(){   
               
            await this.$http.get(`${baseApiUrl}/unidades/orgaos/all`).then(res =>{
                this.orgaos = res.data
            })
        },
        carregaUnidades(){
            this.unidades =  []
            this.unidadeSelecionada = null
            this.$http.get(`${baseApiUrl}/unidades/orgao/${this.orgaoSelecionado.orgao.idenOrgao}`).then(res =>{
                this.unidades = res.data
            })
        },
        fecharFiltro(){
            this.tipoRelatorioSelecionado = null
            this.orgaoSelecionado = null
            this.unidadeSelecionada = null
            this.tipoAfastamentoFiltroSelecionado = null
            this.faseFiltroSelecionado = null,
            this.tipoJornadaFiltroSelecionado = null,
            this.matriculaFiltro = null
            this.cpfFiltro = null
            this.status = null
        },
        relatorioDireitoAfastamento(){     
            if(this.orgaoSelecionado){                
                let bodyRelatorio = {
                    numrMatricula: this.matriculaFiltro? this.matriculaFiltro : null ,
                    idenOrgao: this.orgaoSelecionado? this.orgaoSelecionado.orgao.idenOrgao: null,
                    //idenUnidade: this.orgaoSelecionado.idenUnidade, 
                    idenUnidadeLotacao: this.unidadeSelecionada? this.unidadeSelecionada.idenUnidade : null,
                    tipoAfastamento: this.tipoAfastamentoFiltroSelecionado? this.tipoAfastamentoFiltroSelecionado.code : null,
                    fase: this.faseFiltroSelecionado? this.faseFiltroSelecionado.code : null,
                    tipoJornada: this.tipoJornadaFiltroSelecionado? this.tipoJornadaFiltroSelecionado.code : null           
                }
                this.$http.post(`${baseApiUrl}/relatorios/direitoafastamento`,JSON.stringify(bodyRelatorio)).then(res =>{
                    this.pdfBase64 = res.data.dadosRelatorioBase64
                    this.nomeModalPDF = "RELATÓRIO DE DIREITO DE AFASTAMENTO"
                    this.exibirPDFDocumento = true
                    this.fecharFiltro()       
                })
            }else{                
                this.$toast.add({severity:'error', summary: 'Erro na Busca', detail:'Por Favor Selecione uma Orgão', life: 8000});
            }
        }
    },
    mounted(){        
        this.carregarDados()
    },
    computed: {
        tempermicao(){
            let possuiPermissao = false
            let perfilUsers = this.$store.getters.getUser.contaAcesso.authorities
            if( perfilUsers && perfilUsers.length > 0){                 
                let permissao = perfilUsers.filter(function (element){ 
                    return element.nomeRole == 'PORT_ACESSO_CENTRAL_RH'
                })
                if(permissao && permissao.length > 0){
                        possuiPermissao = true
                }

            }
            return possuiPermissao
        }
    }


}
</script>

<style>
.text-center{
    text-align: center;
}
.cursor-poiter{
    cursor: pointer;
}
</style>